import { CampaignMediaDto } from '@shelflix/trpc/routes/campaign/get/useCase';
import Icon from '@shelflix/ui-web/components/Icon';
import { Card, CardContent } from '@shelflix/ui-web/components/ui/card';
import { Separator } from '@shelflix/ui-web/components/ui/separator';
import { Skeleton } from '@shelflix/ui-web/components/ui/skeleton';
import { useState } from 'react';

interface MediaCardProps {
  media: CampaignMediaDto;
}

export function MediaCard({ media }: MediaCardProps) {
  const [imageLoaded, setImageLoaded] = useState(true);
  const [imageSrc, setImageSrc] = useState(media.mediaUrl);

  return (
    <Card className="w-[198px] gap-0 overflow-hidden rounded-[10px] py-0">
      <div className="h-[140px] w-full overflow-hidden rounded-[4px] px-4 py-4">
        {!imageLoaded ? (
          <Skeleton className="absolute inset-0 h-full w-full" />
        ) : (
          <div className="h-full w-full overflow-hidden rounded-[4px]">
            {['mp4', 'mov', 'webm'].includes(media.extension ?? '') ? (
              <video src={imageSrc} />
            ) : (
              <img
                className="h-full w-full object-cover"
                alt={media.name + ' logo'}
                src={imageSrc}
                onError={() => {
                  setImageSrc('https://shelflix.com.br/wp-content/uploads/2025/02/Grey_Orange-300x90.png'); //TODO deixar imagem padrão de fallback
                  setImageLoaded(false);
                  setTimeout(() => setImageLoaded(true), 3000);
                }}
              />
            )}
          </div>
        )}
      </div>
      <CardContent className="flex flex-col space-y-3 p-4">
        <div className="flex flex-col items-center gap-2">
          <div className="flex w-full justify-center rounded-[5px] border border-solid border-[#6d6d6d] py-1">
            <span className="text-md flex items-center gap-1 font-['Figtree',Helvetica] leading-5 font-medium text-[#6d6d6d]">
              <Icon name="timer" fill={1} size={20} />
              {media.duration}s
            </span>
          </div>

          <span className="line-clamp-2 max-h-[3.5rem] overflow-hidden font-['Poppins',Helvetica] text-[14px] leading-snug font-medium break-words text-[#2d2d2d]">
            {media.name}
          </span>

          <Separator className="bg-[#d9d9d9]" />
          <div></div>
        </div>
      </CardContent>
    </Card>
  );
}
